import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingProfessionalAiHeadshotsConfig } from '@/data/landingConfig/landingProfessionalAiHeadshotsConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ProfessionalAiHeadshots } from './schemaObject';

interface Props {}
const ProfessionalAiHeadshots: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ProfessionalAiHeadshots} />
			<LandingTemplate
				data={landingProfessionalAiHeadshotsConfig}
				funnelLinkService={GenerateLandingLinkService.funnelHeadshotGenerator()}
			/>
		</>
	);
};

export default ProfessionalAiHeadshots;
